<template>
  <div style="display: none" />
</template>

<script>
import { mapGetters } from 'vuex'

import { EventBus } from '@/services/eventbus'

export default {
  props: {
    /**
     * Indicates whether the MapBox instance is ready
     */
    loaded: {
      type: Boolean,
      required: true,
    },
    layerVisibility: {
      type: Boolean,
      default: false,
    },
    minZoom: {
      required: true,
      type: Number,
    },
    maxZoom: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {
      layerName: 'lb_ls_kabel',
      type: 'line',
      icon: '',
      paint: {
        'line-width': 1.5,
      },
      layout: {
        'visibility': this.layerVisibility ? 'visible' : 'none',
      },
    }
  },
  computed: {
    ...mapGetters('deployment', [
      'MapboxAccount',
      'DeploymentLayerName',
    ]),
    ...mapGetters('prognose', [
      'labelLayer',
    ]),
    source() {
      return {
        url: `mapbox://${this.MapboxAccount}.${this.sourceName}`,
        layer: this.sourceName,
      }
    },
    sourceName() {
      return this.DeploymentLayerName({ layer: this.layerName })
    },
  },
  watch: {
    loaded: {
      immediate: true,
      handler(loaded) {
        if (!loaded) return

        this.addLayer()
      },
    },
    layerVisibility: {
      handler(visible) {
        !visible ? this.removeLayerAndSource() : this.addLayer()
      },
    },
  },
  methods: {
    /**
     * Add the layer
     */
    addLayer() {
      this.removeLayerAndSource()

      if (! this.sourceName) return

      if (! this.source.url || ! this.source.layer) return

      if (this.$store.map.getLayer(this.layerName)) {
        this.$store.map.removeLayer(this.layerName)
      }
      if (this.$store.map.getSource(this.sourceName)) {
        this.$store.map.removeSource(this.sourceName)
      }
      this.$nextTick(() => {
        this.$store.map.addSource(this.sourceName, {
          type: 'vector',
          url: this.source.url,
        })
        
        this.$store.map.addLayer({
          'id': this.layerName,
          'type': this.type,
          'source': this.sourceName,
          'source-layer': this.source.layer,
          'minzoom': this.minZoom,
          'maxzoom': this.maxZoom,
          'paint': {
            ...this.paint,
            'line-color': [
              'match',
              ['to-string', ['get', 'Spanningsniveau']],
              '0.23', '#FF0091',
              '0.4', '#FF0000',
              /* default value */ '#B3B3B3'
            ]
          },
          'layout': {
            ...this.layout
          },
        }, this.labelLayer)
        
        EventBus.$emit('layers.national.loaded', {
          name: this.layerName,
        })
      })
    },
    removeLayerAndSource () {
      if (this.$store.map.getLayer(this.layerName)) {
        this.$store.map.removeLayer(this.layerName)
        this.$store.map.removeSource(this.sourceName)
      }
    },
  },
}
</script>
